import SaleStatisticsLink from '../components/DataTable/StatisticsLinkCell';
import ResponsiveDateCell from '../components/DataTable/ResponsiveDateCell';

const DATA_TITLE = 'data-title';

/**
 * Config for statistics table filter
 */
export default {
    url: '/bloodstock/sales/statistics/data.json',
    columns: [
        {
            columnName: 'sale_date',
            displayName: 'Date',
            headerDataAttrs: {
                [DATA_TITLE]: 'date'
            },
            customCell: {
                component: ResponsiveDateCell
            }
        },
        {
            columnName: 'sale_name',
            displayName: 'Sale',
            headerDataAttrs: {
                [DATA_TITLE]: 'sale-name'
            },
            customCell: {
                component: SaleStatisticsLink,
                options: {
                    columnUid: 'venue_uid',
                    columnDate: 'sale_raw_date',
                    columnPast: 'is_past'
                }
            }
        },
        {
            columnName: 'sale_co',
            displayName: 'Sale co',
            headerDataAttrs: {
                [DATA_TITLE]: 'sale-company'
            }
        }
    ]
};



// WEBPACK FOOTER //
// ./src/js/config/statisticsCataloguesTable.js